import {japaneseFormService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        forms: [],
        selectedForm: undefined,
    },

    mutations: {
        saveForms(current, forms) {

            current.forms = [...forms];
        },
        saveSelectedForm(current, form) {
            current.selectedForm = {...form};
        }
    },

    actions: {
        async getFormAction({commit}, id) {
            return await bindLoading(commit,
                async () => {
                    const rst = await japaneseFormService.get(id);
                    commit('saveSelectedForm', rst)
                    return rst;
                }, 'form');
        },
        async getstudFormsAction({ commit }) {

            await bindLoading(commit,
                async () => commit('saveSelectedForm', await japaneseFormService.getstud()), 'form');
        },
        async getFormsAction({commit}) {
            await bindLoading(commit,
                async () => commit('saveForms', await japaneseFormService.getAll()), 'form');
        },


        async getstudentFormsAction({ commit }) {
            await bindLoading(commit,
                async () => commit('saveForms', await japaneseFormService.getstudentAll()), 'form');
        },

        async insertFormAction({ commit, state }, form) {
            return await bindLoading(commit,
                async () => {
                    const res = await japaneseFormService.insert(form);
                    if (res.success) {
                        commit('saveForms', [res.instance, ...state.forms]);
                    }
                    return res;
                }, 'form',{exposure:true});
        },

        async removeFormAction({commit, state}, id) {
            return await bindLoading(commit,
                async () => {
                    const res = await japaneseFormService.remove(id);
                    if (res.success) {
                        commit('saveForms', state.forms.filter(f => f.id !== id));
                    }
                    return res;
                }, 'form');
        },

        async updateFormAction({commit, state}, form) {
            return await bindLoading(commit,
                async () => {
                    const res = await japaneseFormService.update({...form});
                    if (res.success) {
                        commit('saveForms', [res.instance, ...state.forms.filter(s => s.id !== form.id)]);
                    }
                    return res;
                }, 'form/update');
        },
        
        async getFormsByInfo({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await japaneseFormService.getFormActionByInfo(item);
                    if (res.success) {
                        commit('saveForms', res.instance);
                    } else {
                        commit('saveForms', []);
                    }
                    return res;
                }, 'form');
        }
    }
};